const CASHIER_USA_SUBDIVISIONS_WE_USE_AS_COUNTRIES = ['AS',
// American Samoa
'FM',
// Micronesia,
'GU',
// Guam,
'MP',
// Northern Mariana Islands,
'PW',
// Palau,
'VI',
// U.S. Virgin Islands
'PR' // Puerto Rico,
];
export function mapToCashierShippingAddress(shippingAddress, billingAddress) {
  if (shippingAddress === void 0) {
    shippingAddress = {};
  }
  if (billingAddress === void 0) {
    billingAddress = {};
  }
  let countryCodeOverride = null;
  let hasSubdivision = !!shippingAddress.state;
  if (shippingAddress.countryCode === 'C2') {
    countryCodeOverride = 'CN';
  }
  if (shippingAddress.countryCode === 'US' && shippingAddress.state && CASHIER_USA_SUBDIVISIONS_WE_USE_AS_COUNTRIES.includes(shippingAddress.state)) {
    countryCodeOverride = shippingAddress.state;
    hasSubdivision = false;
  }
  const countryCode = countryCodeOverride ?? shippingAddress.countryCode ?? billingAddress.countryCode;
  return {
    countryCode,
    city: shippingAddress.city,
    postalCode: shippingAddress.postalCode,
    addressLine1: shippingAddress.addressLine1,
    addressLine2: shippingAddress.addressLine2,
    firstName: shippingAddress.firstName ?? billingAddress.firstName,
    lastName: shippingAddress.lastName ?? billingAddress.lastName,
    state: hasSubdivision ? `${countryCode}-${shippingAddress.state}` : undefined,
    email: billingAddress.email,
    phone: shippingAddress.phone || billingAddress.phone
  };
}
export function cashierContactToUpdateAddressRequest(contact) {
  return {
    country: (contact == null ? void 0 : contact.countryCode) ?? null,
    subdivision: (contact == null ? void 0 : contact.state) ?? null,
    postalCode: (contact == null ? void 0 : contact.postalCode) ?? null,
    city: (contact == null ? void 0 : contact.city) ?? null,
    streetAddress: null,
    addressLine1: (contact == null ? void 0 : contact.addressLine1) ?? null,
    addressLine2: (contact == null ? void 0 : contact.addressLine2) ?? null
  };
}
export function cashierContactToUpdateContactRequest(contact) {
  return {
    firstName: (contact == null ? void 0 : contact.firstName) ?? null,
    lastName: (contact == null ? void 0 : contact.lastName) ?? null,
    phone: (contact == null ? void 0 : contact.phone) ?? null,
    company: null,
    vatId: null
  };
}
//# sourceMappingURL=addresses.utils.js.map